import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { DxFormComponent } from 'devextreme-angular';
import { ToastrService } from 'ngx-toastr';
import { TextTemplateCreationAndUpdateModel } from 'src/app/models/text-templates/text-template-creation-and-update.model';
import { TextTemplateTypeModel } from 'src/app/models/text-templates/text-template-type.model';
import { TextTemplateModel } from 'src/app/models/text-templates/text-template.model';
import { LoadingService } from 'src/app/services/loading.service';
import { TextTemplateService } from 'src/app/services/text-template.service';

@Component({
  selector: 'app-save-text-template-modal',
  standalone: false,
  templateUrl: './save-text-template-modal.component.html',
  styleUrl: './save-text-template-modal.component.scss',
})
export class SaveTextTemplateModalComponent {
  @ViewChild('templateForm', { static: false }) 
  templateForm!: DxFormComponent;
  
  @Input()
  type!: TextTemplateTypeModel;

  @Input()
  content!: string;

  @Input() showModal = false;
  @Output() showModalChange = new EventEmitter<boolean>();

  @Output() onSave = new EventEmitter<TextTemplateModel>();
  @Output() onCancel = new EventEmitter();

  formData = { 
    name: '' 
  };

  constructor(
    private toastrService: ToastrService,
    private loadingService: LoadingService,
    private translateService: TranslateService,
    private textTemplateService: TextTemplateService,
  ) {

  }

  public onSaveClick() {
    const isFormValid = this.templateForm.instance.validate().isValid;
    if(!isFormValid) return;

    const model: TextTemplateCreationAndUpdateModel = {
      name: this.formData.name,
      content: this.content,
      type: this.type
    };

    this.loadingService.load(
      this.textTemplateService.addTextTemplate(model)
    ).subscribe({
      next: (result) => {
        this.toastrService.success(
          this.translateService.instant(
            'TEXT-TEMPLATES.TEXT-TEMPLATE-SAVED'
          )
        );

        this.onSave.emit(result);
        this.close();
      },
      error: (err) => {
        const code = err?.error?.code;
        if (code === 'TEMPLATE_ALREADY_EXISTS') {
          this.toastrService.warning(
            this.translateService.instant(
              'TEXT-TEMPLATES.TEMPLATE-ALREADY-EXISTS'
            )
          );
        } else {
          this.toastrService.error(
            this.translateService.instant(
              'COMMON.AN-ERROR-HAS-OCCURRED'
            )
          );
        }
      },
    });
  }

  public cancel() {
    this.onCancel.emit();
    this.close();
  }

  close() {
    this.showModal = false;
    this.showModalChange.emit(this.showModal);
  }
}
